import { Banner, Button, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import logo from "@/assets/logo.svg";
import useSegmentEvent from "@/hooks/useSegmentEvent";

type PublicReviewBannerProps = {
  companyName: string;
};

export default function PublicReviewBanner({
  companyName,
}: PublicReviewBannerProps) {
  const { t } = useTranslation(["review"]);

  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <Banner className="gap-x-2xs mt-sm">
      <img src={logo} className="size-md" />
      <Typography step="-1" weight="semibold">
        {t("review:banner.public.title", { companyName })}
      </Typography>
      <Button
        intent="secondary"
        as="a"
        href="https://www.hellocarbo.com/reservez-votre-demo/?utm_source=produit&utm_medium=in-app&utm_campaign=bilanpublic"
        onClick={() => sendSegmentEvent("Demo booked through public review")}
        shouldOpenNewTab
      >
        {t("review:banner.public.primaryAction")}
      </Button>
      <Button
        intent="secondary"
        as="a"
        href="https://pro.hellocarbo.com/"
        onClick={() => sendSegmentEvent("Free trial through public review")}
        shouldOpenNewTab
      >
        {t("review:banner.public.secondaryAction")}
      </Button>
    </Banner>
  );
}
